import { defineStore } from 'pinia'
import usersService from "@/services/users.service";
import {fragmentUserForUserStore} from "@/graphql/fragments/query/users.fragments";

export const useUserStore = defineStore('user', {
  state: () => ({
    id: '',
    email: '',
    ip_country: null,
    name: '',
    role: '',
    avatar: '',
    profile: '',
    oauth: [],
    phone: null,
    interface_lang: '',
    tarifs: [],
    period_starts_at: null,
    created_at: null,
    quizCounter: 0,
    leadCounter: 0,
    is_blocked: false,
    learning_center: null,
    bonuses: [],
    isUserDataLoading: false,
    isUserDataLoaded: false,
  }),
  getters: {
    userData(state) {
      return {
        id: state.id,
        email: state.email,
        ip_country: state.ip_country,
        name: state.name,
        role: state.role,
        avatar: state.avatar,
        profile: state.profile,
        oauth: state.oauth,
        phone: state.phone,
        interface_lang: state.interface_lang,
        tarifs: state.tarifs,
        period_starts_at: state.period_starts_at,
        created_at: state.created_at,
        quizCounter: state.quizCounter,
        leadCounter: state.leadCounter,
        is_blocked: state.is_blocked,
        learning_center: state.learning_center,
        bonuses: state.bonuses,
        isUserDataLoading: state.isUserDataLoading,
        isUserDataLoaded: state.isUserDataLoaded,
      }
    },
  },
  actions: {
    setUserData(user) {
      this.id = user.id || '';
      this.email = user.email || '';
      this.ip_country = user.ip_country || null;
      this.name = user.name || '';
      this.role = user.role || '';
      this.avatar = user.avatar || '';
      this.profile = user.profile || '';
      this.oauth = Array.isArray(user.oauth) ? user.oauth : [];
      this.phone = user.phone || null;
      this.interface_lang = user.interface_lang || '';
      this.tarifs = user.tarifs || [];
      this.period_starts_at = user.period_starts_at || null;
      this.created_at = user.created_at || null;
      this.quizCounter = user.quizCounter || 0;
      this.leadCounter = user.leadCounter || 0;
      this.is_blocked = user.is_blocked || false;
      this.learning_center = user.learning_center || null;
      this.bonuses = user.bonuses || [];
      this.isUserDataLoaded = true;
    },

    // Profile fields only (fragmentUserForProfile). Never touches tarifs, bonuses
    // or the loaded flag, which only a full user response may set.
    setProfileData(user) {
      if (!user) {
        return;
      }
      this.id = user.id || '';
      this.email = user.email || '';
      this.name = user.name || '';
      this.avatar = user.avatar || '';
      this.is_blocked = user.is_blocked || false;
      this.profile = user.profile || '';
      this.role = user.role || '';
      this.phone = user.phone || null;
    },

    updateLearningCenter(learningCenter) {
      this.learning_center = learningCenter || null;
    },

    updateUserAvatar(avatar) {
      this.avatar = avatar;
    },

    async fetchUserData(current) {
      if (this.isUserDataLoading) {
        return;
      }

      this.isUserDataLoading = true;

      try {
        const user = await usersService.getUserData({
          fragment: fragmentUserForUserStore,
          variables: { current } ,
        });
        this.setUserData(user);
      } catch (error) {
        console.log(error);
      } finally {
        this.isUserDataLoading = false;
      }
    }
  }
})
